import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import ScrollProgress from './components/ScrollProgress';
import Navbar     from './components/Navbar';
import Hero       from './components/Hero';
import About      from './components/about/About';
import Skills     from './components/Skills';
import Experience from './components/experience/Experience';
import Contact    from './components/Contact';

ReactDOM.render(
  <React.StrictMode>
    <ScrollProgress />
    <Navbar />
    <main>
      <Hero />
      <About />
      <Skills />
      <Experience />
      <Contact />
    </main>
  </React.StrictMode>,
  document.getElementById('root')
);
